import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/app/accounting/")({
  beforeLoad: () => {
    throw redirect({ to: "/app/accounting/gl-transactions" })
  },
})
